/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 定額制プランへの変更を当日から適用する際にUPDATEするBody
 * @export
 * @interface UpdatePlanBody
 */
export interface UpdatePlanBody {
    /**
     * プランID
     * "03" -> 月間契約プラン
     * "04" -> 半年間契約プラン
     * "05" -> 年間契約プラン
     * 
     * 仕様上、定額制プランへの変更のみ適用できる
     * @type {string}
     * @memberof UpdatePlanBody
     */
    planId: string;
    /**
     * 自動更新するか
     * @type {boolean}
     * @memberof UpdatePlanBody
     */
    isAutoRenewable: boolean;
    /**
     * 一括請求か
     * @type {boolean}
     * @memberof UpdatePlanBody
     */
    isLumpSumPayment: boolean;
}

export function UpdatePlanBodyFromJSON(json: any): UpdatePlanBody {
    return UpdatePlanBodyFromJSONTyped(json, false);
}

export function UpdatePlanBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdatePlanBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'planId': json['plan_id'],
        'isAutoRenewable': json['is_auto_renewable'],
        'isLumpSumPayment': json['is_lump_sum_payment'],
    };
}

export function UpdatePlanBodyToJSON(value?: UpdatePlanBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'plan_id': value.planId,
        'is_auto_renewable': value.isAutoRenewable,
        'is_lump_sum_payment': value.isLumpSumPayment,
    };
}

